import * as React from "react";
import Component from "../../AbstractComponent";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";


export default class PropertySummary extends Component {
	public state = {
		
	};

  constructor(public props) {
    super(props);
	}
	
  public render() {
		const property: PropertyInterface = this.props.property;
  
		return (
			<div className="charge-summary">
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
					<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
						{this.trans("label-address")}
					</div>
				</div>
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
					<div className="counterparty">

						{`${property?.address?.formattedAddress}`}
					</div>
				</div>
				<table>
					<tr>
						<td className="align-left first-column">
							{`${this.trans("owner")}: `}
						</td>
						<td className="align-left">
							<div className="margin-wrapper">
								<div 
									className="link-to-entity" 
									onClick={() => this.redirect(`/app/owner/update/${property?.companyId}/`)}
								>
									{`${property?.company?.displayName}`}
								</div>
							</div>
						</td>
					</tr>
				</table>
			</div>
		);
  }
}
